import { attr, BaseModel } from "../../lib/itn-ui-kit/data";

export default class AddressModel extends BaseModel {
  static urlPath = "address";

  @attr("string") streetNumber;
  @attr("string") route;
  @attr("string") raw;
  @attr("string") formatted;
  @attr("string") suiteNumber;
  @attr("string") suiteType;
  @attr("string") extraInfo;
  @attr("string") city;
  @attr("string") postCode;
  @attr("string") county;
  @attr("string") state;
  @attr("string") stateCode;
  @attr("string") country;
  @attr("string") countryCode;
  @attr("boolean") validated;
  @attr("number") latitude;
  @attr("number") longitude;
}
